import { Component } from '@angular/core';

import { BannerComponent } from '../banner/banner.component';

@Component({
  selector: 'bkg-dialog-banner',
  template: `
    <div *ngIf="isVisible" class="banner banner--error mb-4">
      <div class="container">
        <div class="banner__content">
          <span> {{ message }} </span>
        </div>
        <button class="banner__close" (click)="onCloseBanner()">
          <img [src]="'assets/images/icons/close-inverse.svg'" />
        </button>
      </div>
    </div>
  `,
})
export class DialogBannerComponent extends BannerComponent {}
